<div class="app-login">
    <div class="body-app mt-3 mb-3">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <div class="content-app">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-2 col-sm-12 col-12">
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-12">
                        <div class="card card-login">
                            <div class="card-body">
                                <a class="d-block mt-1 mb-1 mx-auto" style="max-width: 400px;">
                                    <img src="assets/Images/logo.jpg" class="img-fluid" alt="logo" />
                                </a>
                                <h5 class="mt-1 mb-1 text-center text-primary">
                                    <i class="fa-solid fa-envelope-circle-check"></i>
                                    Verificación de Correo
                                </h5>
                                <hr class="mt-2 mb-3" />
                                
                                <!-- Paso 1: Solicitar código de verificación -->
                                @if (step() === 1) {
                                    <div class="alert alert-warning" role="alert">
                                        <i class="fa-solid fa-triangle-exclamation me-2"></i>
                                        Para continuar utilizando la plataforma, es necesario que verifiques tu dirección de correo electrónico.
                                    </div>
                                    
                                    <p class="text-center">
                                        Se enviará un código de verificación a tu correo electrónico.
                                        Por favor revisa tu bandeja de entrada (incluyendo la carpeta de spam) e ingresa el código recibido.
                                    </p>
                                    
                                    <p class="text-center">
                                        <small class="text-muted">El código de verificación expira después de 15 minutos.</small>
                                    </p>
    
                                    <div class="mt-3 mb-2">
                                        <button (click)="resendVerificationEmail()" type="button" 
                                                class="btn btn-primary w-100"
                                                [disabled]="!canResend() || isLoading()">
                                            @if (!isLoading()) {
                                                <i class="fa-solid fa-paper-plane"></i>
                                            }@else {
                                                <div class="spinner-border spinner-border-sm text-light" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            }
                                            Enviar código de verificación
                                            @if (countdown() > 0) {
                                                ({{countdown()}}s)
                                            }
                                        </button>
                                    </div>
                                }
                                
                                <!-- Paso 2: Ingresar código de verificación -->
                                @if (step() === 2) {
                                    <div class="alert alert-info" role="alert">
                                        <i class="fa-solid fa-info-circle me-2"></i>
                                        Hemos enviado un código de verificación a tu correo electrónico.
                                    </div>
                                    
                                    <form [formGroup]="verificationForm">
                                        <div class="form-group mb-3">
                                            <label>Código de verificación</label>
                                            <div>
                                                <input formControlName="verificationCode" type="text" class="form-control" 
                                                    placeholder="Ingrese el código recibido" maxlength="8"/>
                                            </div>
                                            @if (verificationForm.get('verificationCode')?.errors && verificationForm.get('verificationCode')?.touched) {
                                                <small class="text-danger">
                                                    El código debe tener entre 6 y 8 caracteres
                                                </small>
                                            }
                                        </div>
                                    </form>
                                    
                                    <div class="mt-3 mb-2">
                                        <button (click)="verifyEmail()" type="button" 
                                                class="btn btn-primary w-100"
                                                [disabled]="verificationForm.invalid || isLoading()">
                                            @if (!isLoading()) {
                                                <i class="fa-solid fa-check-circle"></i>
                                            }@else {
                                                <div class="spinner-border spinner-border-sm text-light" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            }
                                            Verificar correo electrónico
                                        </button>
                                    </div>
                                    
                                    <div class="mt-3 mb-2">
                                        <button (click)="resendVerificationEmail()" type="button" 
                                                class="btn btn-outline-primary w-100"
                                                [disabled]="!canResend() || isLoading()">
                                            <i class="fa-solid fa-paper-plane"></i>
                                            Reenviar código
                                            @if (countdown() > 0) {
                                                ({{countdown()}}s)
                                            }
                                        </button>
                                    </div>
                                }
                                
                                <div class="mt-3">
                                    <button (click)="logout()" type="button" class="btn btn-outline-secondary w-100">
                                        <i class="fa-solid fa-right-from-bracket"></i>
                                        Cerrar sesión
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-2 col-sm-12 col-12">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
